import { Skeleton } from '@material-ui/lab';
import { FC, useEffect } from 'react';
import { useReleaseDetailPageContext } from '../../context/useReleaseDetailPageContext';
import { LatestProvisioningDetail } from './LatestProvisioningDetail';

export const LatestProvisioning: FC<{ canProvision: boolean }> = ({
  canProvision,
}) => {
  const { fetchDeploys, deploysState, setTestTaskId } =
    useReleaseDetailPageContext();
  const { loading, value } = deploysState;

  useEffect(() => {
    fetchDeploys({ includeSnapshots: false });
  }, [fetchDeploys]);

  useEffect(() => {
    if (!loading && value?.[0]?.steps?.[0]?.subPlanId) {
      setTestTaskId(value[0].steps[0].subPlanId);
    }
  }, [value, loading, setTestTaskId]);

  const deploy = value?.[0];

  if (loading) return <Skeleton width="100%" height={50} />;

  if (deploy)
    return (
      <LatestProvisioningDetail deploy={deploy} canProvision={canProvision} />
    );

  return null;
};
